import { render } from "./App.vue?vue&type=template&id=87d09b2c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=87d09b2c&lang=scss"
script.render = render

export default script